<div class="d-flex">
  <app-components-navbar></app-components-navbar>
  <div class="capsule">
    <app-navtabs [type]="'compromise-reports'"></app-navtabs>
  </div>
</div>
